var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Layout,[_c('BaseContent',{attrs:{"title":"Genres & Moods"}},[_c('BaseSection',{attrs:{"padded":""}},[_c(_setup.GenreGridBlock,{attrs:{"genres":_setup.activeGenres,"followed-genre-ids":_setup.followedGenreIds},on:{"toggle-follow":_setup.handleToggleFollow}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }